const lightPalette = {
  transparent: 'transparent',
  black: '#000000',
  white: '#FFFFFF',
  milk:'#F9FAFB',
  chalk:'#E4E7EC',

  grey: {
    0: '#ffffff',
    100: '#FCFCFD',
    200: '#F9F9FB',
    300: '#F0F0F3',
    400: '#E8E8EC',
    500: '#E0E1E6',
    600: '#D9D9E0',
    700: '#CDCED6',
    800: '#B9BBC6',
    900: '#8B8D98',
    1000: '#80838D',
    1100: '#60646C',
    1200: '#1C2024',
    white: '#ffffff',
    black: '#111111',
  },
  blue: {
    100: '#fdfdfe',
    200: '#f6f9ff',
    300: '#ebf2ff',
    350: '#E1ECFF',
    400: '#ddeaff',
    500: '#ccdfff',
    600: '#b8d2ff',
    700: '#a0bfff',
    800: '#7fa5fc',
    900: '#1434cb',
    1000: '#0c1bb7',
    1100: '#2d57d9',
    1200: '#182c64',
  },

  turquoise: {
    100: '#fafefd',
    200: '#f3fbf9',
    300: '#dff8f3',
    400: '#ccf3ec',
    500: '#b7ebe1',
    600: '#a0ded3',
    700: '#82cec1',
    800: '#52b9aa',
    900: '#00a393',
    1000: '#009687',
    1100: '#008072',
    1200: '#0e3d37',
  },
  green: {
    100: '#fafefb',
    200: '#f4fbf6',
    300: '#e6f7e9',
    400: '#E6F7E9',
    500: '#c4eacb',
    600: '#abe0b6',
    700: '#8ad19a',
    800: '#56bc73',
    900: '#109648',
    1000: '#118741',
    1100: '#00813b',
    1200: '#1b3d24',
  },

  purple: {
    100: '#fcfbfe',
    200: '#f7f5fd',
    300: '#efecfb',
    400: '#e0d9f8',
    600: '#643fdb',
    700: '#5536ba',
  },
  red: {
    100: '#fffcfc',
    200: '#fff7f7',
    300: '#feebea',
    400: '#ffdcd8',
    500: '#ffcec9',
    600: '#fdbeb8',
    700: '#f5aaa4',
    800: '#eb8f89',
    900: '#de4043',
    1000: '#d02e35',
    1100: '#cd2e35',
    1200: '#64191a',
  },
  yellow: {
    100: '#fefdfb',
    200: '#fffae9',
    300: '#fff2c1',
    400: '#ffe89e',
    500: '#ffdd79',
    600: '#fdd175',
    700: '#ebc067',
    800: '#d9a939',
    900: '#ffc610',
    1000: '#f9bd20',
    1100: '#9c6e00',
    1200: '#46391d',
  },
};

//dark mode colors
const darkPalette = {
  transparent: 'transparent',
  black: '#000000',
  white: '#FFFFFF',
  milk:'#F9FAFB',
  chalk:'#E4E7EC',

  grey: {
    0: '#0c1119',
    100: '#111113',
    200: '#18191B',
    300: '#212225',
    400: '#272A2D',
    500: '#2E3135',
    600: '#363A3F',
    700: '#43484E',
    800: '#5A6169',
    900: '#696E77',
    1000: '#777B84',
    1100: '#B0B4BA',
    1200: '#EDEEF0',
    white: '#ffffff',
    black: '#111111',
  },

  blue: {
    100: '#071026',
    200: '#0b1632',
    300: '#081b66',
    400: '#081c8b',
    500: '#0c25a4',
    600: '#1231b8',
    700: '#183cd2',
    800: '#1d45f6',
    900: '#1434cb',
    1000: '#0e29a8',
    1100: '#8db4ff',
    1200: '#cee2ff',
  },

  turquoise: {
    100: '#0b1311',
    200: '#101c1a',
    300: '#0d2d29',
    400: '#033b34',
    500: '#094840',
    600: '#14574e',
    700: '#1c695f',
    800: '#1e7f73',
    900: '#1e7f73',
    1000: '#1e7f73',
    1100: '#53d2c1',
    1200: '#a9f0e4',
  },
  green: {
    100: '#0c130e',
    200: '#121b14',
    300: '#152c1b',
    400: '#153b20',
    500: '#1b4928',
    600: '#235832',
    700: '#2b693d',
    800: '#317d47',
    900: '#109648',
    1000: '#38834d',
    1100: '#61d381',
    1200: '#b2f2bf',
  },
  purple: {
    100: '#fcfbfe',
    200: '#f7f5fd',
    300: '#efecfb',
    400: '#e0d9f8',
    600: '#643fdb',
    700: '#5536ba',
  },
  red: {
    100: '#170f0e',
    200: '#201312',
    300: '#3b1312',
    400: '#510f11',
    500: '#611718',
    600: '#732424',
    700: '#8c3432',
    800: '#b54543',
    900: '#de4043',
    1000: '#bc4b48',
    1100: '#ff8f88',
    1200: '#ffd2ce',
  },
  yellow: {
    100: '#13110b',
    200: '#1c1810',
    300: '#2c220a',
    400: '#3c2900',
    500: '#493300',
    600: '#56400c',
    700: '#6a521e',
    800: '#866929',
    900: '#fcc026',
    1000: '#f1b60a',
    1100: '#ffca3c',
    1200: '#fee7b8',
  },
};

export { lightPalette, darkPalette };
